import Dropdown, { Placement } from "../Dropdown";
import React from "react";
import styles from "./MoreEditButton.module.scss";
import SvgButton from "../svg-button";
import {
  AIClothSvg,
  AIFaceUnblur,
  AIHairSvg,
  AIReplaceSvg,
  AIUpScaleSvg,
  EditorSvg,
  MagicEraser,
  MoreSvg,
} from "@/assets/icons";
import { useTranslation } from "react-i18next";
import { withBaseUrl } from "@/utils";
import { useCommonStore } from "@/stores";
import { getEditorSecondLink } from "@/utils/link";
import { useIsMobile } from "@/hooks";
import Tooltip from "../tooltip";
import Analyse from "@/utils/analyse";
import useEffectStore from "@/stores/effectStore";
interface MoreEditButtonProps {
  classNames?:string;
  onOpenChange?: (show: boolean) => void;
}
const enum EDIT_MORE_BUTTONS {
  MagicEraser = "magic-remove",
  AIUpSacler = "ai-enlarger",
  FaceUnBlur = "photo-unblur",
  AIReplace = "ai-replacer",
  AIHairstyle = "AIHairstyle",
  AIClothesChanger = "ai-clothes",
}

type ButtonItem = {
  key: EDIT_MORE_BUTTONS;
  i18n: string;
  icon: React.ReactNode;
  analyseKey: string;
};
const BUTTONS = (isMobile = false) =>
  [
    {
      key: EDIT_MORE_BUTTONS.MagicEraser,
      i18n: "more_edit_button_magic_eraser",
      icon: <MagicEraser />,
      analyseKey: "magic_eraser",
    },
    {
      key: EDIT_MORE_BUTTONS.AIUpSacler,
      i18n: "more_edit_button_ai_up_sacler",
      icon: <AIUpScaleSvg />,
      analyseKey: "ai_upscaler",
    },
    {
      key: EDIT_MORE_BUTTONS.FaceUnBlur,
      i18n: "more_edit_button_face_un_blur",
      icon: <AIFaceUnblur />,
      analyseKey: "face_unblur",
    },
    {
      key: EDIT_MORE_BUTTONS.AIReplace,
      i18n: "more_edit_button_ai_replace",
      icon: <AIReplaceSvg />,
      analyseKey: "ai_replace",
    },
    {
      key: EDIT_MORE_BUTTONS.AIHairstyle,
      i18n: "more_edit_button_ai_hairstyle",

      icon: <AIHairSvg />,
      analyseKey: "ai_hairstyle",
    },
    {
      key: EDIT_MORE_BUTTONS.AIClothesChanger,
      i18n: isMobile
        ? "more_edit_button_ai_clothes_changer_mobile"
        : "more_edit_button_ai_clothes_changer",
      icon: <AIClothSvg />,
      analyseKey: "ai_clothes",
    },
  ] as ButtonItem[];

export default function MoreEditButton(props: MoreEditButtonProps) {
  const { t } = useTranslation();
  const { onOpenChange,classNames } = props;
  return (
    <Dropdown
      zIndex={5000}
      placement={Placement.bottomLeft}
      className={styles.modal}
      popContent={<MoreEditMenu />}
      onOpenChange={(show) => {
        if (show) {
          Analyse.getInstance().featureClick("edit");
        }
        onOpenChange?.(show);
      }}
    >
      <SvgButton className={classNames}>
        <Tooltip content={t("edit-tip")} placement="top"></Tooltip>
        <EditorSvg />
      </SvgButton>
    </Dropdown>
  );
}
export const MoreEditMenuWrapperClassName = styles.modal;
export const MoreEditMenu = () => {
  const { t } = useTranslation();
  const task = useEffectStore((state) => state.task);
  const isMobile = useIsMobile();
  const handleMenu = (key: string, item: ButtonItem) => {
    Analyse.getInstance().featureClick(item.analyseKey);
    const src = task?.pictureUrl ?? "";
    let link = process.env.REACT_APP_BASE_URL;
    if (key === EDIT_MORE_BUTTONS.AIHairstyle) {
      link = withBaseUrl(
        `photo-editor-app/editor/beauty/ai-hairstyle?bg_url=${src}&bg_type=url`
      );
    } else {
      link = getEditorSecondLink(key, task?.pictureUrl ?? "");
    }
    window.open(link, "_blank");
  };

  return (
    <ul className={styles.menus}>
      {BUTTONS(isMobile).map((item) => (
        <li
          className={styles.menu}
          key={item.key}
          onClick={() => handleMenu(item.key, item)}
        >
          <span className={styles.icon}>{item.icon}</span>
          <span className={styles.text}>{t(item.i18n)}</span>
        </li>
      ))}
    </ul>
  );
};
